import React, { useState, useRef, useEffect } from "react";
import { Field, FieldProps } from "formik";
import { CountryCodeSelector } from "./CountryCodeSelector";
import { RequiredLabel } from "../Login/Login";

interface PhoneInputFieldProps {
  name: string;
  selectedCountryCode: string;
  onCountryChange: (dialCode: string, countryCode: string) => void;
  disabled?: boolean;
}

declare const state: any;

export const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  name,
  selectedCountryCode,
  onCountryChange,
  disabled = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const { value } = field;
        const { setFieldValue } = form;

        // Ensure value always starts with country code
        const displayValue = value || selectedCountryCode + " ";

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          let inputValue = e.target.value;

          // If the input is empty, reset to country code + space
          if (inputValue === "") {
            setFieldValue(name, "");
            return;
          }

          // If user tries to type the country code, remove it and use the selected one
          if (inputValue.startsWith(selectedCountryCode)) {
            inputValue = inputValue.substring(selectedCountryCode.length);
          }

          // Always prepend the selected country code
          const finalValue = selectedCountryCode + " " + inputValue.trimStart();
          setFieldValue(name, finalValue);
        };

        const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
          // If field is empty or only contains the country code, set cursor to end
          if (!value || value.length <= selectedCountryCode.length + 1) {
            setTimeout(() => {
              e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            }, 0);
          }
        };

        return (
          <div className="form-span input-container phone-input-container">
            <i className="la la-phone la-lg input-icon" />
            <CountryCodeSelector value={selectedCountryCode} onChange={onCountryChange} disabled={disabled} />
            <input
              {...field}
              type="text"
              className="form-input input-field phone-input"
              maxLength={255}
              placeholder={state.translate("register.enterPhoneNumber", "Enter phone number...")}
              value={displayValue}
              onChange={handleChange}
              onFocus={handleFocus}
              disabled={disabled}
            />
            <label className="input-label">
              {state.translate("register.phone", "Phone number")}
              <RequiredLabel />
            </label>
          </div>
        );
      }}
    </Field>
  );
};
